import React from 'react';

import classNames from 'classnames';

import styles from './LayoutWrapper.module.css';

export enum LayoutWidth {
  Narrow = 'Narrow',
  Normal = 'Normal',
}

export type Props = {
  children: React.ReactNode;
  className?: string;
  isDefaultVerticalPadding?: boolean;
  size?: LayoutWidth;
};

export const LayoutWrapper = React.memo((props: Props) => {
  const {
    children,
    className,
    size = LayoutWidth.Normal,
    isDefaultVerticalPadding = false,
  } = props;

  return (
    <div
      className={classNames(styles.layoutWrapper, {
        [styles.defaultVertical]: isDefaultVerticalPadding,
        [styles.narrow]: size === LayoutWidth.Narrow,
      }, className)}
    >
      {children}
    </div>
  );
});

LayoutWrapper.displayName = 'LayoutWrapper';
